import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/feature/SchemaOrg';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import CategorySection from './components/CategorySection';
import LatestSection from './components/LatestSection';
import FaqSection from './components/FaqSection';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [location.pathname]);

  return (
    <>
      <SchemaOrg
        type="Organization"
        data={{
          name: '妖精动漫',
          url: 'https://yaojingdongman.com',
          description: '妖精动漫精选无删减韩国漫画，下拉式阅读模式搭配免费韩漫大全，资源丰富、界面友好，操作简单便捷，让您轻松找到心仪的韩漫作品。',
          sameAs: ['https://yaojingdongman.com'],
        }}
      />
      <SchemaOrg
        type="WebSite"
        data={{
          name: '妖精动漫',
          url: 'https://yaojingdongman.com',
          description: '韩国漫画无删减漫画下拉式-免费韩漫大全',
          potentialAction: {
            '@type': 'SearchAction',
            target: 'https://yaojingdongman.com/search?q={search_term_string}',
            'query-input': 'required name=search_term_string',
          },
        }}
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: '妖精动漫 - 韩国漫画无删减漫画下拉式-免费韩漫大全',
          description: '妖精动漫精选无删减韩国漫画，下拉式阅读模式搭配免费韩漫大全，资源丰富、界面友好，操作简单便捷，让您轻松找到心仪的韩漫作品。',
          url: 'https://yaojingdongman.com',
          isPartOf: {
            '@type': 'WebSite',
            name: '妖精动漫',
          },
        }}
      />
      <SchemaOrg
        type="FAQPage"
        data={{
          mainEntity: [
            {
              '@type': 'Question',
              name: '妖精动漫网站上的韩国漫画都是免费的吗？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '是的，妖精动漫上的所有韩国漫画均免费提供阅读。我们致力于为广大韩漫爱好者打造一个无门槛的阅读平台，所有作品均可免费畅读，无需付费订阅。',
              },
            },
            {
              '@type': 'Question',
              name: '什么是下拉式漫画阅读模式？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '下拉式漫画阅读模式是一种专为移动端和网页端优化的漫画呈现方式。与传统翻页模式不同，下拉式模式将漫画所有画面纵向排列，读者只需向下滑动即可连续阅读，无需点击翻页按钮，阅读体验更加流畅自然。',
              },
            },
          ],
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturedSection />
          <CategorySection />
          <LatestSection />
          <FaqSection />
        </main>
        <Footer />
      </div>
    </>
  );
}